import React from 'react';
import {FormattedMessage} from 'react-intl';
import {toAbsoluteUrl} from '../../../../_metronic/_helpers';

export function BooleanColumnFormatter(cellContent, labelTrue, labelFalse) {
  return (
    <div className="font-weight-bolder font-size-lg flex-nowrap d-flex justify-content-center">
      <img src={toAbsoluteUrl(`/media/svg/${cellContent ? 'Check.svg' : 'Cross.svg'}`)} alt="icon"/>
      <div
        style={{color: cellContent ? '#28a745' : '#dc3545'}}
        className={'ml-2'}
      >
        {cellContent
          ? labelTrue ?? <FormattedMessage id={'label-exists'} defaultMessage="Exists"/>
          : labelFalse ?? <FormattedMessage id={'label-does-not-exist'} defaultMessage="Does not exist"/>
        }
      </div>
    </div>
  );
}
